/* eslint-disable camelcase */
import axios from 'axios'
// import modules from '~/modules'
// import Cookies from 'js-cookie'

export const state = {
  completedEvents: [],
  pageEvents: new Map(),
  actionQueue: [],
  currentPhase: 0,
  taskCompletion: new Map(),
  phases: [],
  pcs: {},
  eventsLoaded: false,
}

export const getters = {
  getCompletedEvents: state => {
    return state.completedEvents
  },
  currentPhase: state => {
    return state.currentPhase
  },
  taskCompletion: state => {
    return state.taskCompletion
  },
  isPhaseComplete: () => (phase) => {
    return !comparator(phase)
  },
  phases: state => {
    return state.phases
  }
}
function comparator(phase) {
  let currPhase = state.taskCompletion.get(phase)
  let nextPhase = state.taskCompletion.get(phase + 1)
  if (nextPhase && (currPhase?.completed?.length == currPhase?.total?.length)) {
    return false
  }
  else if (!nextPhase && (currPhase?.completed?.length == currPhase?.total?.length)) {
    return true
  }
  return (currPhase && currPhase.completed?.length != currPhase.total?.length) 
}

// dispatch
export const actions = {
  clearState: ({ commit }) => {
    commit('CLEAR_STATE')
    commit('email/CLEAR_STATE', null, { root: true })
    commit('video call/CLEAR_STATE', null, { root: true })
    commit('group/CLEAR_STATE', null, { root: true })
    commit('roles/CLEAR_STATE', null, { root: true })
    commit('cirt/CLEAR_STATE', null, { root: true })
    commit('research consent/CLEAR_STATE', null, { root: true })
    commit('chat/CLEAR_STATE', null, { root: true })
  },
  addCompletedEvent: async ({ commit, dispatch, store }, payload) => {
    commit('ADD_EVENT', payload.event)
    await dispatch('saveState', payload.classId)
  },
  /*
   * saves info in the store to the db so it can be retrieved on a page refresh or if the user logs in on another computer
   */
  saveState: async ({ state, rootState }, classId = rootState.auth.classId) => {
    // Convert map for storage
    let pageEvents = []
    let keys = Array.from(state.pageEvents.keys())
    if(keys){
      keys.forEach(key  => {
        pageEvents.push({key: key, value: state.pageEvents.get(key)})
      })
    }
    else pageEvents = undefined;
    const saveState = {
      completedEvents: state.completedEvents,
      pageEvents: pageEvents,
      actionQueue: state.actionQueue,
    }
    await axios.post("/api/updateModule", {
      params: {
        state: saveState,
        pcs: localStorage.getItem('pcs'),
        classId: classId,
      },
    })
  },
  /*
  this is called when the user logs in for the first time or if the page is refreshed.
  gets all saved progress from the db and populates it to the state
   */
  populateStateFromDB: async ({ commit, dispatch, state, rootState }, vue) => {
    let response = await axios.post('/api/load_pcs_info', {
      params: {
        pcsId: localStorage.getItem('pcs'),
      }
    })
    commit('SET_PCS', response.data)
    dispatch('auth/setClassId', JSON.parse(localStorage.getItem('userClass')), { root: true })
    dispatch('group/getGroup', null, { root: true }).then(
      axios
        .post('/api/getState', {
          params: {
            pcs: localStorage.getItem('pcs'),
            classId: rootState.auth.classId,
          },
        })
        .then( async response => {
          let newState = JSON.parse(response.data.state)
          if (newState.completedEvents) {
            commit('POPULATE_STATE', newState)
          }
          else {
            await axios.post('/api/log_error', {
              params: {
                error: 'Completed events not found for user ' + rootState.auth.user.id,
              }
            })
          }

          const moduleStates = response.data[0]
          moduleStates.forEach(async ({ content, module_id, module_name }) => {
            if (typeof content === 'string') {
              content = JSON.parse(content)
            }
            // navbar, tour, email, risk assessment, documentation
            await dispatch(`${module_name}/populateFromDB`, content, { root: true })
          })
          // dispatch('documentation/getArticles', null, { root: true })
          let currentEvents = state.completedEvents
          if (currentEvents[currentEvents.length - 1] === 0) {
            // checks to see if event 0 has been processed. If it
            // hasn't been processed then we process event 0
            await dispatch('events/processEvent', {eventId: 0} , { root: true })
          }
          
          
          // Calculate current day in PCS
          dispatch('computeCurrentPhase')

          // Run manually triggered actions
          let queueIsEmpty = !newState.actionQueue.length
          while(newState.actionQueue.length) {
            let action = newState.actionQueue.shift()
            dispatch(action.action, action.content, { root: true })
          }
          if (!queueIsEmpty) {
            commit('UPDATE_ACTION_QUEUE', newState.actionQueue)
            await dispatch('saveState', rootState.auth.classId)
          }

          if (newState.processQueue) {
            while(newState.processQueue.length) {
              let event = newState.processQueue.shift()
              dispatch('events/processEvent', {eventId: event}, { root: true })
            }
          }
          commit('SET_EVENTS_LOADED', true)
        })
    )
  },
  updateActionQueue: async ({ commit, dispatch, state, rootState }, action) => {
    let response = await axios
      .post('/api/getState', {
        params: {
          pcs: localStorage.getItem('pcs'),
          classId: rootState.auth.classId,
        },
      })
    let newActionQueue = JSON.parse(response.data.state).actionQueue || []
    commit('UPDATE_ACTION_QUEUE', newActionQueue)
  },
  removeActionFromQueue: ({ commit, dispatch, state, rootState }, action) => {
    let index = state.actionQueue.findIndex((actionInQueue) => {
      return actionInQueue.action === action.action && JSON.stringify(actionInQueue.content) === JSON.stringify(action.content)
    })
    if (index !== -1) {
      commit('REMOVE_ACTION_FROM_QUEUE', index)
      dispatch('saveState', rootState.auth.classId)
    }
  },
  processEvent: async ({ commit, dispatch, state, rootState }, payload) => {
    try {
      let pcs_id = localStorage.getItem('pcs')
      if (payload.moduleContent !== undefined) {
        if (payload.moduleContent.hasOwnProperty('pcs_id')) {
          pcs_id = payload.moduleContent.pcs_id
        }
        if (payload.moduleContent.hasOwnProperty('class_id')) {
          payload.moduleContent = payload.moduleContent.class_id
        }
      }
      let response = await axios.post('/api/processEvent', { // Returns array of events with actions to run
        params: {
          eid: parseInt(payload.eventId),
          pcs_id: pcs_id,
          content: (payload.moduleContent !== undefined) ? payload.moduleContent : '',
          class_id: rootState.auth.classId,
          teammateEvent: payload.teammateEvent,
        },
      })
      await dispatch('updateActionQueue')
      await dispatch('events/addCompletedEvent', {event: parseInt(payload.eventId), classId: rootState.auth.classId}, { root: true })
      if (response.data) {
        let events = response.data // Array of events with actions to run
        events.forEach(event => { // For each event in the array
          event.action.forEach(action => { // For each action in event
            if (!action.role || (rootState.group.role && action.role === rootState.group.role.role_id)) { // If event doesn't have a role OR the role matches the current user's role
              if (event.delay) {
                if (action.action == "chat/sendMessage") {
                  dispatch('chat/addTyping', action.content.sender, { root: true })
                }
                setTimeout(() => {
                  let actionJson = JSON.stringify(action)
                  if (action.action == "chat/sendMessage") {
                    dispatch('chat/removeTyping', action.content.sender, { root: true })
                  }
                  dispatch(action.action, action.content, { root: true })
                  dispatch('removeActionFromQueue', JSON.parse(actionJson))
                }, event.delay * 1000)
              }
              else {
                let actionJson = JSON.stringify(action)
                dispatch(action.action, action.content,  { root: true }) // Run the action on the frontend
                dispatch('removeActionFromQueue', JSON.parse(actionJson))
              }
            }
          })
        })
      }
      dispatch('computeCurrentPhase')
      return true
    } catch (err) {
      await axios.post('/api/log_error', {
        params: {
          error: err.message + " for user " + rootState.auth.user.id,
        }
      })
      console.error("Failed")
      console.error(err)
      return false
    }
  },
  // For logging all types of actions
  logAction: async ({ commit, dispatch, state, rootState }, payload) => {
    let groupId = rootState.group.group.id === "" ? null : rootState.group.group.id
    axios.post('/api/log_action', {
      params: {
        action: payload.action,
        content: payload.content ?? null,
        ids: {
          group_id: groupId,
          pcs_id: localStorage.getItem('pcs') ?? null,
          class_id: rootState.group.classId
        }
      }
    })
  },
  
  watchPage: async ({ commit, dispatch }, payload) => {
    commit('ADD_WATCH_PAGE', payload)
    await dispatch('saveState')
  },
  
  clearPageWatch: async ({ commit, dispatch }, payload) => {
    commit('REMOVE_WATCH_PAGE', payload)
    await dispatch('saveState')
  },
  
  computeCurrentPhase: async ({ commit, dispatch, rootState}) => {
    axios.post('/api/pcs/tasks', {
      params: {
        pcs: localStorage.getItem('pcs'),
        class_id: rootState.auth.classId,
      },
    })
    .then(response => {
      let tasks = response.data.filter(task => {
        let actions = JSON.parse(task.action)
        if (actions.length > 1){ // Multiple roles in one event
          return actions.some(action => action.role === rootState.group.role.role_id)
        }
        else {
          if (actions[0]?.role && rootState.group.role.role_id){
            return (actions[0].role === rootState.group.role.role_id)
          }
          else {
            return true;
          }
        }
      })
      commit('UPDATE_TASK_COMPLETION', tasks)
      state.phases.sort((a, b) => a - b)
      let currentPhase = state.phases.find(phase => comparator(phase)) || 0
      commit('SET_CURRENT_PHASE', currentPhase)
      return currentPhase
    })
  },
}

// commit
export const mutations = {
  SET_PCS: (state, pcs) => {
    state.pcs = pcs
  },
  POPULATE_STATE: (state, newState) => {
    state.completedEvents = newState.completedEvents
    if (newState.pageEvents){
      newState.pageEvents.forEach(pair => {
        state.pageEvents.set(pair.key, pair.value)
      })   
    } else state.pageEvents = new Map()
  },
  UPDATE_ACTION_QUEUE: (state, newActionQueue) => {
    state.actionQueue = newActionQueue
  },
  REMOVE_ACTION_FROM_QUEUE: (state, index) => {
    state.actionQueue.splice(index, 1)
  },
  ADD_EVENT: (state, event) => {
    state.completedEvents.push(event)
  },
  CLEAR_STATE: state => {
    state.completedEvents = []
    state.pageEvents = new Map()
    state.actionQueue = []
    state.phases = []
    state.taskCompletion = new Map()
    state.phases = []
    state.pcs = {}
    state.eventsLoaded = false
  },
  ADD_WATCH_PAGE: (state,payload) => {
    state.pageEvents.set(payload.page, payload.event_id)
  },
  REMOVE_WATCH_PAGE: (state,payload) => {
    state.pageEvents.delete(payload.page)
  },
  SET_CURRENT_PHASE: (state, payload) => {
    state.currentPhase = payload
  },
  UPDATE_TASK_COMPLETION: (state, tasks) => {
    state.taskCompletion = new Map()
      state.phases = []
      tasks.forEach((task) => {
        if (!state.phases.includes(task.phase)) {
          state.phases.push(task.phase)
          state.taskCompletion.set(task.phase, {completed: [], total: []})
        }
        let currCompletion = state.taskCompletion.get(task.phase)
        currCompletion.total.push(task.event_id)
        if (task.completion_time != null) {
          currCompletion.completed.push(task.event_id)
        }
        state.taskCompletion.set(task.phase, currCompletion)
      })
  },
  SET_EVENTS_LOADED: (state, payload) => {
    state.eventsLoaded = payload
  }
}
